<template>
   <div id="page-loading">
        <div class="progress" id="progress">
            <span id="progress-span"></span>
        </div>
        <p id="loading-text">加载中...</p>
    </div>
</template>
<script>
export default {
  data() {
    return {
      progressTimer: ''
    }
  },
  mounted() {
    var i = 0;
    this.progressTimer = setInterval(function() {
      if (i < 4) {
        i += 0.15
        document.getElementById('progress-span').style.left = i + 'rem';
      } else {
        i = 0;
        document.getElementById('progress-span').style.left = i + 'rem';
      }
    }, 20)
  },
  destroyed() {
    clearInterval(this.progressTimer)
  }
}
</script>
<style lang="scss" scoped>
 #page-loading {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: contain;
      z-index: 9;
    }

    #loading5 {
      position: absolute;
      width: .4rem;
      height: .4rem;
      left: 50%;
      margin-left: -.2rem;
      top: 40%;
    }
    #loading-img{
      width:7.5rem;
      height: 100%;
    }

    .demo5 {
      width: .4rem;
      height: .4rem;
      border-radius: 50%;
      background: #fff;
      animation: demo5 cubic-bezier(0.5, 0.01, 0.9, 1) 0.6s infinite alternate;
      -webkit-animation: demo5 cubic-bezier(0.5, 0.01, 0.9, 1) 0.6s infinite alternate;
    }

    @keyframes demo5 {
      0% {
        transform: translateY(0px);
        -webkit-transform: translateY(0px);
      }

      100% {
        transform: translateY(80px);
        -webkit-transform: translateY(80px);
      }
    }

    @-webkit-keyframes demo5 {
      0% {
        transform: translateY(0px);
        -webkit-transform: translateY(0px);
      }

      100% {
        transform: translateY(80px);
        -webkit-transform: translateY(80px);
      }
    }
    .progress{
      position: absolute;
      width: 4rem;
      height: 15px;
      border: 1px solid orange;
      left: 50%;
      margin-left: -2rem;
      bottom: 1rem;
      overflow: hidden;
    }
    .progress span{
      display: block;
      width:10px;
      height: 15px;
      background:orange;
      position: absolute;
    }
    #page-loading #loading-text{
      position: absolute;
      width: 4rem;
      height: .6rem;
      color: orange;
      left: 50%;
      margin-left: -2rem;
      bottom: 1.4rem;
      overflow: hidden;
      text-align: center;
      font-size:.3rem;
    }
</style>
